module.exports = __webpack_public_path__ + "img/icon-twitter.b2e397be.svg";